export default __webpack_public_path__ + "static/FT-logo-white-small-d01f2e47946a567641e4e3e1c7ceb66f.svg";